import { ImportCommentsButton, ExportCommentsButton } from 'feature/developer/import-export';
import { component, feature, demoFile } from 'system/demo';

demoFile('feature/developer/import-export');

component('ImportCommentsButton', ImportCommentsButton);
component('ExportCommentsButton', ExportCommentsButton);
feature('import-comments', {structureKey: 'simplecomments'});
feature('export-comments', {structureKey: 'simplecomments'});
